import { render, staticRenderFns } from "./ClienteLikes.vue?vue&type=template&id=085444a4"
import script from "./ClienteLikes.vue?vue&type=script&lang=js"
export * from "./ClienteLikes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports